const check = () => {
  if (!window.localStorage) {
    console.warn('LocalStorage not supported')
    return false
  }
  return true
}

// ------------ Exportables -----------------------

const getLocation = () => {
  if (!check()) return false

  const lat = parseFloat(localStorage.getItem('lat'))
  const lon = parseFloat(localStorage.getItem('lon'))
  const city = localStorage.getItem('city')

  if (!(lat && lon)) return false

  return {lat, lon, city}
}

const setLocation = ({lat, lon, city}) => {
  if (!check() && lat && lon) return false

  localStorage.setItem('lat', lat)
  localStorage.setItem('lon', lon)
  localStorage.setItem('city', city)

  return true
}

const removeLocation = () => {
  if (!check()) return false

  localStorage.removeItem('lat')
  localStorage.removeItem('lon')
  localStorage.removeItem('city')

  return true
}

const setDistance = distance => {
  if (!check() || !Number.isInteger(distance)) return false

  localStorage.setItem('distance', distance)
  return true
}

const getDistance = () => {
  if (!check()) return false

  return localStorage.getItem('distance')
}

const removeDistance = () => {
  if (!check()) return false

  localStorage.removeItem('distance')
  return true
}

const getTokens = () => {
  if (!check()) return false

  const bearer = localStorage.getItem('bearer')
  const refresh = localStorage.getItem('refresh')

  if (!(bearer || refresh)) return false

  return {bearer, refresh}
}

const setTokens = ({bearer, refresh}) => {
  if (!check()) return false

  if (!(bearer && refresh)) return false

  localStorage.setItem('bearer', bearer)
  localStorage.setItem('refresh', refresh)

  return true
}

const removeTokens = () => {
  if (!check()) return false

  localStorage.removeItem('bearer')
  localStorage.removeItem('refresh')

  return true
}

const setCategoriesTree = items => {
  if (!check()) return false

  localStorage.setItem('categoriesTree', JSON.stringify(items))
  localStorage.setItem('categoriesTreeStoredAt', new Date())
}

const getCategoriesTree = () => {
  if (!check()) return false
  const jcats = localStorage.getItem('categoriesTree')

  return JSON.parse(jcats)
}

// Generic localStorage methods
const get = (key) => {
  if (!check()) return null
  const item = localStorage.getItem(key)
  try {
    return JSON.parse(item)
  } catch(e) {
    return item
  }
}

const set = (key, value) => {
  if (!check()) return false
  try {
    localStorage.setItem(key, typeof value === 'string' ? value : JSON.stringify(value))
    return true
  } catch(e) {
    return false
  }
}

const remove = (key) => {
  if (!check()) return false
  localStorage.removeItem(key)
  return true
}

// ----------- checking timeout data -------------

const checkableProps = [
  'categoriesTree'
]

const checkTimeout = date => (new Date() - date) > 2 * 3600 * 1000

const checkCleanStorage = props => props.map(prop => {
  const storedDate = new Date(localStorage.getItem(`${prop}StoredAt`))

  return checkTimeout(storedDate) && localStorage.removeItem(prop)
})

checkCleanStorage(checkableProps)

export default {
  getLocation,
  setLocation,
  removeLocation,
  getDistance,
  setDistance,
  removeDistance,
  getTokens,
  setTokens,
  removeTokens,
  setCategoriesTree,
  getCategoriesTree,
  get,
  set,
  remove
}



// WEBPACK FOOTER //
// ./src/localStorage.js